import { render, staticRenderFns } from "./add-organization-modal.vue?vue&type=template&id=790c8109&scoped=true"
import script from "./add-organization-modal.vue?vue&type=script&lang=js"
export * from "./add-organization-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c8109",
  null
  
)

export default component.exports